module.exports = new __parcel__URL__("error-message.5ab52acf.png").toString();